import React from 'react';
import { ActivityIndicator } from 'react-native';
import DownloadIcon from './DownloadIcon';
import Button from './Button';

interface ExportButtonProps {
  onPress: () => void,
  exporting?: boolean,
}

const ExportButton = ({ onPress, exporting }: ExportButtonProps) => <Button
  style={{ width: 119 }}
  disabled={exporting}
  title={'Export\t'}
  affirmative
  children={exporting ? <ActivityIndicator /> : <DownloadIcon />}
  {...{ onPress }}
/>;

export default ExportButton;
